import React from "react";

const renderIcon = (book) => {
  const postContentType = book?.book || "";

  if(postContentType === "MTEVM"){
    return <img alt="mtevm icon" src="/images/pmbok-mtevm-icon.svg" width="45" />;
  }
  if(postContentType === "MTPMO"){
    return <img alt="mtevm icon" src="/images/pmopg-icon.svg" width="45" />;
  }

  if (postContentType === "MTPmbok6") {
    return <img alt="pmbok6 icon" src="/images/pmbok6-icon.svg" width="45" />;
  }
  if (postContentType === "MTPmbok7") {
    return <img alt="pmbok7 icon" src="/images/pmbok7-icon.svg" width="45" />;
  }
  if (postContentType === "MTAPG") {
    return <img alt="apg icon" src="/images/apg-icon.svg" width="45" />;
  }
  if (postContentType === "MTGBA") {
    return <img alt="gba icon" src="/images/gba-icon.svg" width="45" />;
  }
  if (postContentType === "MTWBS") {
    return <img alt="wbs icon" src="/images/wbs-icon.svg" width="45" />;
  }
  if (postContentType === "MTSRM") {
    return <img alt="srm icon" src="/images/srm-icon.svg" width="45" />;
  }
  if (postContentType === 'MTSPE') {
    return <img alt="srm icon" src="/images/mtse-icon.svg" width="45" />;
  }
  if (postContentType === 'MTPGP') {
    return <img alt="pgp icon" src="/images/pgp-icon.svg" width="45" />;
  }
  if (postContentType === 'MTBAG') {
    return <img alt="mtbag icon" src="/images/mtbag-icon.svg" width="45" />;
  }
  if (postContentType === "MTSPM") {
    return <img alt="apg icon" src="/images/mtspm-icon.svg" width="45" />;
  }
  if (postContentType === "MTRMP") {
    return <img alt="MTRMP icon" src="/images/risk-icon.svg" width="45" />;
  }
  return <img src="/images/standards-plus-icon.svg" width="45" />;
};

const TocHeader = ({ book }) => {
  return (
    <div>
      <div
        className="flex flex-wrap justify-center sm:flex-no-wrap sm:justify-between items-center px-5 py-2 w-full border-b border-gray-500"
      >
        <div className="flex items-center">
          {renderIcon(book)}
          <div className="text-xl font-normal text-black pl-3 header-font">
            {book.label}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TocHeader;
